import type { ReactNode } from 'react';
import type { FilterFieldOption } from '~/components/ui';
import { FilterRowsPanel } from '~/components/ui/FilterRowsPanel';
import { newOrderFilterRow } from '~/pages/orders/lib/orderFilterFields';
import type { OrderFilterRow } from '~/pages/orders/lib/orderFilters';

type OrdersFilterProps = {
  readonly rows: OrderFilterRow[];
  readonly maxHeight?: number;
  readonly fieldOptions: FilterFieldOption[];
  readonly bottomContent?: ReactNode;
  readonly onRowsChange: (rows: OrderFilterRow[]) => void;
};

export function OrdersFilter({
  rows,
  maxHeight,
  fieldOptions,
  bottomContent,
  onRowsChange,
}: OrdersFilterProps) {
  return (
    <FilterRowsPanel
      namespace="order"
      keyPrefix="order.filter"
      rows={rows}
      fieldOptions={fieldOptions}
      newRow={newOrderFilterRow}
      initialValueFor={() => ''}
      valueInputFor={() => undefined}
      maxHeight={maxHeight}
      bottomContent={bottomContent}
      onRowsChange={onRowsChange}
    />
  );
}
